import React from 'react'
import styled, { css } from 'styled-components'
import { buttonSizes, colors } from '../../styles/constants'

export const StyledButton = styled.button`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  background-color: transparent;
  border: none;
  width: 100%;
  height: ${({ size }) => buttonSizes[size] ?? buttonSizes.default};
  line-height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  padding: 0 16px;

  border-radius: 8px;
  background-color: ${({ color }) => color || colors.cyan.default};
  color: ${colors.white};
  &:focus {
    outline: none;
  }
  ${({ secondary }) => secondary && css`
    background-color: ${colors.transparent};
    color: ${({ color }) => color || colors.cyan.default};
    &:disabled {
      color: ${colors.gray.light};
      background: ${colors.transparent};
    }
  `}
  ${({ outline }) => outline && css`
    background-color: transparent;
    border: 1px solid ${({ color }) => color || colors.cyan.default};
    color: ${({ color }) => color || colors.cyan.default};
  `}
  ${({ disabled }) => disabled && css`
    background-color: ${colors.gray.default};
    color: ${colors.gray.light};
    border: none;
  `}
`
const Button = ({ children, ...rest }) => {
  return <StyledButton {...rest}>{children}</StyledButton>
}

export default Button
